export default "__VITE_ASSET__6ff277ba__"